import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";
import SessionStorageHandler from "./sessionStorageHandler";

export default class VisualQaHandler {

    constructor(apiHost) {
        this.apiHost = apiHost;
        this.sessionStorageHandler = new SessionStorageHandler();
    }

    getVisualQaExperimentalResponses = async (query_text, image_url) => {
        let inputs = [query_text, image_url]
        let input_key = inputs.join(" ").trim()
        let cached_value = this.sessionStorageHandler.getItem(input_key);
        if (cached_value) {
            return cached_value;
        }
        
        const path = `/default`;
        let responses = await Promise.all([
            ApiCallerClient.callApi({
                "endpoint": {
                    "hostName": this.apiHost,
                    "httpMethod": ApiMethod.POST,
                    "path": path
                },
                "body": JSON.stringify({
                    "query": query_text, 
                    "image_url": image_url, 
                    "invoke_ngs": true,
                    "invoke_mmir": true,
                    "invoke_mmlm": true
                }, null, 2)
            }),
            ApiCallerClient.callApi({
                "endpoint": {
                    "hostName": this.apiHost,
                    "httpMethod": ApiMethod.POST,
                    "path": path
                },
                "body": JSON.stringify({
                    "query": query_text, 
                    "image_url": image_url, 
                    "invoke_ngs": false,
                    "invoke_mmir": true,
                    "invoke_mmlm": true
                }, null, 2)
            }),
            ApiCallerClient.callApi({
                "endpoint": {
                    "hostName": this.apiHost,
                    "httpMethod": ApiMethod.POST,
                    "path": path
                },
                "body": JSON.stringify({
                    "query": query_text, 
                    "image_url": image_url, 
                    "invoke_ngs": true,
                    "invoke_mmir": false,
                    "invoke_mmlm": true
                }, null, 2)
            }),
            ApiCallerClient.callApi({
                "endpoint": {
                    "hostName": this.apiHost,
                    "httpMethod": ApiMethod.POST,
                    "path": path
                },
                "body": JSON.stringify({
                    "query": query_text, 
                    "image_url": image_url, 
                    "invoke_ngs": false,
                    "invoke_mmir": false,
                    "invoke_mmlm": true
                }, null, 2)
            })
        ]);
        let [parametricWithMmirNgs, parametricWithMmir, parametricWithNgs, parametric] = responses;
        console.log('API Responses:', {
            parametricWithMmirNgs,
            parametricWithMmir,
            parametricWithNgs,
            parametric
        });
        this.sessionStorageHandler.addItem(input_key, responses);
        return {
            "parametricWithMmirNgs": parametricWithMmirNgs?.body ? JSON.parse(parametricWithMmirNgs.body) : null,
            "parametricWithMmir": parametricWithMmir?.body ? JSON.parse(parametricWithMmir.body) : null,
            "parametricWithNgs": parametricWithNgs?.body ? JSON.parse(parametricWithNgs.body) : null,
            "parametric": parametric?.body ? JSON.parse(parametric.body) : null
        };
    }
}